import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { PROPERTY_BLOCK_WITHOUT_COMMUNITY } from "./apiRoutes";

const getPropertyBlocksZoneWise = async () => await axiosAuth.get(`${PROPERTY_BLOCK_WITHOUT_COMMUNITY}/community-zone-wise`);

const useGetPropertyBlocksZoneWise = (
  queryParams?: Omit<UseQueryOptions, "queryKey">
): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["property-blocks-community-zone-wise"],
    queryFn: () => getPropertyBlocksZoneWise(),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetPropertyBlocksZoneWise;
